import { useState } from 'react';

interface UseHoveredResponse {
  /** State to determine if the element is hovered. */
  isHovered: boolean;
  /* Handler for mouse enter event. */
  handleMouseEnter: () => void;
  /* Handler for mouse leave event. */
  handleMouseLeave: () => void;
}

/**
 * Custom hook to determine if an element is hovered.
 * It sets isHovered to true when the mouse enters the element and resets when the mouse leaves.
 */
export default function useIsHovered(): UseHoveredResponse {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return {
    isHovered,
    handleMouseEnter,
    handleMouseLeave,
  };
}
